import { useRef, useState } from 'react';
import Picker from 'emoji-picker-react';
import { BsEmojiSmile, BsPaperclip } from 'react-icons/bs';
import { IoSend } from 'react-icons/io5';
import ImagePickerCompressor from './imagePickerCompressor';

export default function MessageComposer({
  newMessage,
  setNewMessage,
  handleSendNewMessage,
  handleImageChange,
  ipcState,
  handleImageClear,
}) {
  const [showPicker, setShowPicker] = useState(false);
  const textareaRef = useRef(null);
  const imagePickerRef = useRef(null);

  const handleEmojiClick = (emojiData) => {
    setNewMessage((prev) => prev + emojiData.emoji);
  };

  const handleSendMessage = () => {
    handleSendNewMessage();
    setShowPicker(false);
  };

  return (
    <>
      <div className="composer">
        <div className="message-input-container">
          {ipcState.previewUrl && (
            <div className="image-preview-container">
              <img src={ipcState.previewUrl} alt="Preview" className="image-preview-thumbnail" />
              <button onClick={handleImageClear} className="clear-image-button">&times;</button>
            </div>
          )}
          <div className="message-input-wrapper">
            <button
              type="button"
              className="emoji-toggle"
              onClick={() => setShowPicker((s) => !s)}
              aria-label="Add emoji"
            >
              <BsEmojiSmile />
            </button>
            <button
              type="button"
              className="attach-button"
              onClick={() => imagePickerRef.current?.pick()}
              aria-label="Attach file"
            >
              <BsPaperclip />
            </button>
            <textarea
              ref={textareaRef}
              className="new-message-entry"
              placeholder="Type your message…"
              value={newMessage}
              onChange={(e) => {
                setNewMessage(e.target.value);
                if (textareaRef.current) {
                  textareaRef.current.style.height = 'auto';
                  textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
                }
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  handleSendMessage();
                }
              }}
            />
            <button type="button" onClick={handleSendMessage} className="send-message-button">
              <IoSend size={24} color="white" />
            </button>
          </div>
        </div>

        {showPicker && (
          <div className="emoji-picker-popover">
            <Picker onEmojiClick={handleEmojiClick} />
          </div>
        )}

        <ImagePickerCompressor
          ref={imagePickerRef}
          onChange={handleImageChange}
          onClear={handleImageClear}
          options={{
            maxSizeMB: 0.8,
            maxWidthOrHeight: 1280,
            minCompressBytes: 0,
            convertTo: 'jpeg',
            skipGif: true,
            force: true,
            initialQuality: 0.7,
          }}
          buttonLabel=""
          className="composer-ipc"
          // Controlled props
          previewUrl={ipcState.previewUrl}
          selectedName={ipcState.selectedName}
          savingsText={ipcState.savingsText}
          compressionProgress={ipcState.compressionProgress}
          error={ipcState.error}
        />
      </div>
    </>
  );
}